export const SET_TURNSTILE_SORT = 'SET_TURNSTILE_SORT'

// Řazení turniketů v TurnstileTable. Vlastní slice (ne filterTurnstile),
// aby přežil refresh přes redux-persist (whitelist ve store.js), zatímco
// filtry se dál resetují.
const defaultState = {
    sort: 'id_asc' // id_asc | id_desc | alerts | name_asc | name_desc | online | type
}

export default function turnstileSort(state = defaultState, action) {
    switch (action.type) {
        case SET_TURNSTILE_SORT:
            return {...state, sort: action.payload}
        default:
            return state
    }
}
